//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
  async fetch() {
    await this.$store.dispatch('pagesStore/getSitemap', this.$route.params.slug)
  },
  head() {
    return {
      meta: [
      { hid: 'robots', name: 'robots', content: 'noindex' },
      ]
    }
  },
  computed: {
    ...mapState({
      sitelinks: ({ pagesStore: {sitelinks} }) => sitelinks,
    }),
  },
}
